/**
 * Handle models view javascript behavior
 */

window.app = window.app || {};

(function (modelsManager, $) {

    /**
     * Switcher selector
     * @type {string}
     * @private
     */
    var _switcher = '.two-column-switcher';

    /**
     * Switcher columns common selector
     * @type {string}
     * @private
     */
    var _switcherColumn = '.switcher-column';

    /**
     * Left column class name
     * @type {string}
     * @private
     */
    var _leftColumnClass = 'left-side';

    /**
     * Right column class name
     * @type {string}
     * @private
     */
    var _rightColumnClass = 'right-side';

    /**
     * Chevron class for column switching
     * @type {string}
     * @private
     */
    var _closingToggle = ".closing-toggle";

    /**
     * left carousel ID
     * @type {string}
     * @private
     */
    var _leftSlider = "#carousel-for-left-side";

    /**
     * right carousel ID
     * @type {string}
     * @private
     */
    var _rightSlider = "#carousel-for-right-side";

    /**
     * bx custom controls: "prev" class
     * @type {string}
     * @private
     */
    var _bxPrevSelector = ".custom-bx-controls .slider-prev";

    /**
     * bx custom controls: "next" class
     * @type {string}
     * @private
     */
    var _bxNextSelector = ".custom-bx-controls .slider-next";

    var _sliderLeft, _sliderRight;

    /**
     * BX Slider Params.
     * @type {{
     *      hideControlOnEnd: boolean,
     *      infiniteLoop: boolean,
     *      pager: boolean,
     *      autoStart: boolean,
     *      nextSelector: string,
     *      prevSelector: string,
     *      nextText: string,
     *      prevText: string,
     *      minSlides: number,
     *      maxSlides: number,
     *      moveSlides: number
     * }}
     */
    var _sliderParams = {
        hideControlOnEnd:   true,
        controls:           true,
        infiniteLoop:       false,
        pager:              false,
        auto:               false,
        preloadImages:      'visible',
        nextSelector:       _leftSlider + ' ' + _bxNextSelector,
        prevSelector:       _leftSlider + ' ' + _bxPrevSelector,
        nextText:           '<i class="icon-chevron"></i>',
        prevText:           '<i class="icon-chevron"></i>',
        minSlides:          1,
        maxSlides:          6,
        slideWidth:         200,
        slideMargin:        80
    };

    /**
     * Clone for bx slider on right side
     * @type {{}}
     * @private
     */
    var _slider2params = $.extend({}, _sliderParams);
    _slider2params.prevSelector = _rightSlider + ' ' + _bxPrevSelector;
    _slider2params.nextSelector = _rightSlider + ' ' + _bxNextSelector;

    /**
     *
     * @type {number}
     * @private
     */
    var _mobileBreakpoint = 767;

    /**
     * Initializes the behavior.
     */
    modelsManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $(document).ready(function(){
            // init bxslider for left side (displayed 1st)
            _sliderLeft = $(_leftSlider + " .bxslider").bxSlider(_sliderParams);

            // init right bxslider
            _sliderRight = $(_rightSlider + " .bxslider").bxSlider(_slider2params);

            _switchOnClick();
            changeOpenedCarousel();

            $(window).on("resize", function(){
                if($(window).outerWidth() <= _mobileBreakpoint){
                    $(_leftSlider).fadeIn(0);
                    $(_rightSlider).fadeIn(0);
                }
            });
        });
    };

    /**
     * toggle switch event
     * @private
     */
    var _switchOnClick = function() {
        $(_switcher + " " + _switcherColumn).on("click", function() {
            _changeOpenedSide($(_switcher + " " + _switcherColumn + ".on " ));
        });
    };

    /**
     * Switch opened side and display corresponding carousel
     * @param _sideToClose
     * @private
     */
    var _changeOpenedSide = function(_sideToClose){
        $(_switcher + " " + _switcherColumn + ".off").addClass("on").removeClass("off");
        $(_sideToClose).removeClass("on").addClass("off");

        if($(_switcher + " " + _switcherColumn + ".on").hasClass(_leftColumnClass)) {
            $(_switcher).addClass("on-left").removeClass("on-right");
            changeOpenedCarousel();
        } else if ($(_switcher + " " + _switcherColumn + ".on").hasClass(_rightColumnClass)) {
            $(_switcher).addClass("on-right").removeClass("on-left");
            changeOpenedCarousel();
        }
    };

    /**
     * Change displayed models carousel
     */
    var changeOpenedCarousel = function(){
        if($(_switcher).hasClass("on-left")){
            $(_rightSlider).fadeOut(function() {
                $(_leftSlider).fadeIn();
                _sliderLeft.reloadSlider();
            });
        } else if($(_switcher).hasClass("on-right")){
            $(_leftSlider).fadeOut(function(){
                $(_rightSlider).fadeIn();
                _sliderRight.reloadSlider();
            });
        }
    };
})(
    window.app.modelsManager = window.app.modelsManager || {},
    jQuery
);
